var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryIcon = function SvgHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5v4.075l3.386 2.032a.75.75 0 0 1-.772 1.286l-3.75-2.25A.75.75 0 0 1 11.25 12V7.5a.75.75 0 1 1 1.5 0M12 3a8.95 8.95 0 0 0-6.367 2.64A39 39 0 0 0 3.75 7.687V6a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 .75.75h3.75a.75.75 0 1 0 0-1.5H4.594c.67-.79 1.338-1.533 2.099-2.303a7.5 7.5 0 1 1 .155 10.757.75.75 0 1 0-1.03 1.092A9 9 0 1 0 12 3"
  })));
};
export default SvgHistoryIcon;